import EditProfileModal from './EditProfile'

export { EditProfileModal }

export const MODALS = {
  editProfile: EditProfileModal
}
